module.exports = __webpack_public_path__ + "static/media/ladies-learning-code.63e19d0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/logos/ladies-learning-code.svg
// module id = 385
// module chunks = 0